import type { InstoreGmvSegments } from '../store-trajectory-values'
import RecapSegmentsPie from './recap-segments-pie'
import { useTranslation } from 'react-i18next'

interface RecapSegmentsProps {
  instoreGmvSegments: InstoreGmvSegments
}

const RecapSegments = ({ instoreGmvSegments }: RecapSegmentsProps) => {
  const { t } = useTranslation()

  return (
    <div className="mg-store-trajectory-recap-segments">
      <div className="mg-store-trajectory-recap-segments-card">
        <div
          className="mg-store-trajectory-recap-segments-card-title vp-body-m"
          data-testid="recap-segments-title-channels"
        >
          {t('general.trajectory.store.recap.channels')}
        </div>
        <RecapSegmentsPie
          data={[
            {
              name: t('general.trajectory.store.recap.channel.physical'),
              value: instoreGmvSegments?.channels?.physical,
              fill: 'var(--vp-semantic-color-extended-cobalt)'
            },
            {
              name: t('general.trajectory.store.recap.channel.digital'),
              value: instoreGmvSegments?.channels?.digital,
              fill: 'var(--vp-semantic-color-extended-turquoise)'
            },
            {
              name: t('general.trajectory.store.recap.channel.decapro'),
              value: instoreGmvSegments?.channels?.decapro,
              fill: 'var(--vp-semantic-color-status-warning)'
            }
          ]}
        />
      </div>
      <div className="mg-store-trajectory-recap-segments-card">
        <div
          className="mg-store-trajectory-recap-segments-card-title vp-body-m"
          data-testid="recap-segments-title-economies"
        >
          {t('general.trajectory.store.recap.economies')}
        </div>
        <RecapSegmentsPie
          data={[
            {
              name: t('general.trajectory.store.recap.economy.circular'),
              value: instoreGmvSegments?.economies?.circular,
              fill: 'var(--vp-semantic-color-extended-green)'
            },
            {
              name: t('general.trajectory.store.recap.economy.non-circular'),
              value: instoreGmvSegments?.economies?.nonCircular,
              fill: 'var(--vp-semantic-color-extended-grey)'
            }
          ]}
        />
      </div>
      <div className="mg-store-trajectory-recap-segments-card">
        <div
          className="mg-store-trajectory-recap-segments-card-title vp-body-m"
          data-testid="recap-segments-title-circulars"
        >
          {t('general.trajectory.store.recap.circulars')}
        </div>
        <RecapSegmentsPie
          data={[
            {
              name: t('general.trajectory.store.recap.circular.repair'),
              value: instoreGmvSegments?.circular?.repair,
              fill: 'var(--vp-semantic-color-extended-cobalt)'
            },
            {
              name: t('general.trajectory.store.recap.circular.second-life'),
              value: instoreGmvSegments?.circular?.secondLife,
              fill: 'var(--vp-semantic-color-extended-turquoise)'
            },
            {
              name: t('general.trajectory.store.recap.circular.buy-back'),
              value: instoreGmvSegments?.circular?.buyBack,
              fill: 'var(--vp-semantic-color-extended-pink)'
            },
            {
              name: t('general.trajectory.store.recap.circular.rental'),
              value: instoreGmvSegments?.circular?.rental,
              fill: 'var(--vp-semantic-color-commercial-default)'
            }
          ]}
        />
      </div>
    </div>
  )
}

export default RecapSegments
